import { useCallback } from 'react';
import { i18n } from 'i18n';

const useChangeLanguage = () => {
  const changeLanguage = useCallback((newLanguageCode) => {
    i18n.changeLanguage(newLanguageCode);
  }, []);

  return changeLanguage;
};

export default useChangeLanguage;
